import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'

// Utils
import { throttle } from '../../utils/helpers/throttle'

const FormItemSpacer = (props) => {
  const { item } = props

  const spacerRef = useRef()

  // Set the height to the height of the first element in the main modal section
  useEffect(() => {
    setSpacerHeight()
    window.addEventListener('resize', setSpacerHeight)
    return () => window.removeEventListener('resize', setSpacerHeight)
  }, [])

  const setSpacerHeight = throttle(() => {
    const firstEl = document.querySelector('.ModalForm-column--main')
    if (firstEl) spacerRef.current.style.setProperty('--height', firstEl.firstChild.clientHeight + 'px')
  }, 100)

  return (
    <div
      ref={spacerRef}
      className={`FormItem FormItem--${item.type}${item.modifier ? ` FormItem--${item.modifier}` : ''}`}
      data-reveal-target={item.revealed}
    ></div>
  )
}

FormItemSpacer.propTypes = {
  item: PropTypes.object
}

export default FormItemSpacer
